const enum RecommendVoActionType {
  SET_RECOMMEND_ITEMS = 'SET_RECOMMEND_ITEMS',
  SET_SELECTED_RECOMMEND_ITEMS = 'SET_SELECTED_RECOMMEND_ITEMS',
}

export { RecommendVoActionType };
